import { Comment, ElementAnno } from '@/types';

class TrackIdGenerator {
  private trackId: number = 0;

  public initTrackId(annotations: ElementAnno[]) {
    for (let i = 0; i < annotations.length; i++) {
      const annotation = annotations[i];
      for (let j = 0; j < annotation.rawdata_annos.length; j++) {
        const rawdataAnno = annotation.rawdata_annos[j];
        for (let k = 0; k < rawdataAnno.objects.length; k++) {
          const obj = rawdataAnno.objects[k];
          const trackId = Number(obj.track_id ?? 0);
          if (trackId > this.trackId) {
            this.trackId = trackId;
          }
        }
      }
    }
  }

  public initCommentTrackId(comments: Array<Comment | null>) {
    comments.forEach((comment) => {
      if (!comment) return;
      const trackId = Number(comment.trackId ?? 0);
      if (trackId > this.trackId) {
        this.trackId = trackId;
      }
    });
  }

  public createTrackId() {
    this.trackId++;
    return String(this.trackId);
  }

  public getCurrent() {
    return this.trackId;
  }

  public setCurrent(id: number) {
    this.trackId = Math.max(id, 0);
  }
}

export const annoTrackIdGenerator = new TrackIdGenerator();
export const commentTrackIdGenerator = new TrackIdGenerator();
